import React, { createContext, useState } from 'react';



export const PaymentTypesContext = createContext();

export const PaymentTypesProvider = ({ children }) => {
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [availablePaymentTypes, setAvailablePaymentTypes] = useState([])
  const [currencies, setCurrencies] = useState([])
  const [availableProducts, setAvailableProducts] = useState()
  const [idCount, setIdCount] = useState(0)

  return (
    <PaymentTypesContext.Provider value={{ 
        paymentTypes, 
        setPaymentTypes, 
        availablePaymentTypes, 
        setAvailablePaymentTypes, 
        currencies, 
        setCurrencies, 
        availableProducts, 
        setAvailableProducts,
        idCount,
        setIdCount
        }}>
      {children}
    </PaymentTypesContext.Provider>
  );
};